var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pan-content"},[_c('pan-header'),_c('pan-navbar'),_c('pan-app-main'),_c('pan-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }